// material-ui

import customhookofficon from '../../../assets/images/custom-hook-off.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const CustomHookoffIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={customhookofficon} alt="Custom Hook Off" width="22"  />
    );
};

export default CustomHookoffIcon;
